import { RootState } from '../RootState';

export const selectUser = (state: RootState) => state.LoginState.user;
export const selectRoles = (state: RootState) => state.LoginState.user.roles;
